import React, { FC } from 'react';

/** @jsx jsx */
import { jsx, css } from '@emotion/core';
import { Clear } from '@css/common.elements';
import { formInputErrorStyle } from '@css/styles';
import { useUniqueId } from '@hooks/useUniqueId';
import {
  FatMode,
  SlimMode,
  RadioOptionGenderWrapper,
  RadioOptionGenderIcon,
  RadioGenderLabel,
  RadioGenderCheckmark,
  RadioGenderOptionContainer,
  RadioGenderOption,
  RadioGenderInput
} from './RadioButton.elements';

const malePrefix = 'radio-gender-male-';
const femalePrefix = 'radio-gender-female-';

interface Props {
  onChange: (e) => void;
  value: string;
  error: boolean;
  displaySlim?: boolean;
}

export const seniorMaleIcn = 'https://media.healthiq.com/marketing/icn/icn56-male-senior-inactive-2x.svg';
export const seniorFemaleIcn = 'https://media.healthiq.com/marketing/icn/icn56-female-senior-inactive.png';

export const maleIcn = 'https://media.healthiq.com/quiz/icn56-male.svg';
export const femaleIcn = 'https://media.healthiq.com/quiz/icn56-female.svg';

export const RadioButtonGender: FC<Props> = ({ onChange, value, error, displaySlim = false }) => {
  const Wrapper = displaySlim ? SlimMode : FatMode;
  const maleId = useUniqueId(malePrefix);
  const femaleId = useUniqueId(femalePrefix);

  return (
    <Wrapper hasError={error}>
      <RadioGenderOptionContainer position="left">
        <RadioGenderOption
          css={error ? formInputErrorStyle : null}
          isSelected={value === "male" ? true : false}
          showBoxShadow={false}
        >
          <RadioOptionGenderWrapper>
            <RadioOptionGenderIcon image={seniorMaleIcn} />
          </RadioOptionGenderWrapper>
          <RadioGenderInput
            id={maleId}
            type="radio"
            value="male"
            name="gender"
            onChange={onChange}
            checked={value === "male"}
          />
          <RadioGenderLabel htmlFor={maleId}>
            Male
          </RadioGenderLabel>
          <RadioGenderCheckmark />
        </RadioGenderOption>
      </RadioGenderOptionContainer>

      <RadioGenderOptionContainer position="right">
        <RadioGenderOption
          css={error ? formInputErrorStyle : null}
          isSelected={value === "female" ? true : false}
          showBoxShadow={false}
        >
          <RadioOptionGenderWrapper>
            <RadioOptionGenderIcon image={seniorFemaleIcn} />
          </RadioOptionGenderWrapper>
          <RadioGenderInput
            id={femaleId}
            type="radio"
            value="female"
            name="gender"
            onChange={onChange}
            checked={value === "female"}
          />
          <RadioGenderLabel htmlFor={femaleId}>
            Female
          </RadioGenderLabel>
          <RadioGenderCheckmark />
        </RadioGenderOption>
      </RadioGenderOptionContainer>
      <Clear />
    </Wrapper>
  );
}
